<template>
  <div class="site-search-bar-results-container" v-if="!hideResults">
    <div
      class="site-search-bar-results"
    >
      <div class="site-search-bar-results-indicators">
        <div v-if="loadingResults">
          <i
            class="fa fa-spinner fa-spin"
            aria-hidden="true"
          />
        </div>
        <div v-if="!loadingResults && !hideResults">
          <a
            class="btn btn-link btn-site-search-bar-submit"
            @click="closeResults"
          >
            <i
              class="fa fa-times-circle-o"
              aria-hidden="true"
            />
          </a>
        </div>
      </div>
      <div
        v-if="results.length > 0 "
        class="site-search-bar-results-response"
      >
        <div class="site-search-bar-results-response-background lines-background">
          &nbsp;
        </div>
        <h2>Search results for: “<span id="site-search-submitted-value-title">{{ store.getSiteSearch() }}”</span></h2>
        <ul class="list list-chevron">
          <li
            v-for="result in results"
            :key="result.id"
            class="txt-size-sm"
          >
            <a
              :id="`sr-${slugify(result.title).toLowerCase()}`"
              :href="result.permalink"
              v-html="result.title"
            />
          </li>
        </ul>
      </div>
      <div
        v-else
        class="site-search-bar-results-response"
      >
        <div class="alert alert-error">No results found for: “<span id="site-search-submitted-value-title-error">{{ store.getSiteSearch() }}</span>”</div>
      </div>
    </div>
  </div>
</template>
<script>

import axios from 'axios';
import slugify from 'slugify';
import { useSiteSearchBarStore } from '../../stores/SiteSearchBarStore';

export default {
  name: 'SiteSearchBarResults',
  data() {
    return {
      store: useSiteSearchBarStore(),
      results: [],
      loadingResults: false,
      hideResults: true,
    };
  },
  watch: {
    'store.searchSubmittedValue'() {
      if (this.store.getSearchSubmitted() === true) {
        this.getResults();
      } else {
        this.closeResults();
      }
    },
    'store.siteSearchValue'() {
      this.getResults();
    },
  },
  methods: {
    slugify,
    closeResults() {
      this.hideResults = true;
      this.store.setSearchSubmitted(false);
    },
    getResults() {
      this.loadingResults = true;
      const vm = this;
      axios.get(`/?s=${vm.store.getSiteSearch()}`)
        .then((response) => {
          vm.results = response.data;
          vm.loadingResults = false;
          vm.hideResults = false;
        })
        .catch((e) => {
          vm.errors.push(e);
        });
    },
  },
};
</script>
